<template>
	<div class="tableSelect">
		<h2 style="text-align: center;margin-bottom: 15px;border-bottom:2px solid #ddd;padding-bottom: 10px;">文章审核</h2>
		<div :style="{'min-height': height+'px'}">
			<el-form :inline="true" label-position="left" style="margin-bottom:50px;">
				
				<el-form-item label="作者" style="width: 48%;">
					<el-input :value="article.author" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="发布时间" prop="publish_time" style="width: 48%;">
					<el-date-picker style="width:100%;" v-model="article.publish_time" value-format="YYYY-MM-DD HH:mm:ss" type="datetime"
						placeholder="请选择发布时间" />
				</el-form-item>
				<el-form-item label="所属栏目" style="width: 48%;">
					<div style="display: flex;width: 100%;">
						<div style="flex: 1;">
							<el-tree style="max-width: 400px" ref="tree1" node-key="id" :props="treeProps" :data="columns1"
								default-expand-all show-checkbox />
						</div>
						<div style="flex: 3;">
							<el-tree style="max-width: 400px" ref="tree2" node-key="id" :props="treeProps" :data="columns2"
								default-expand-all show-checkbox />
						</div>
					</div>
				</el-form-item>
			</el-form>
			<h2 class="article-title">{{article.title}}</h2>
			<div class="article-desc">
				<span>投稿日期：{{article.create_datetime}}</span>
				<span> 来源：{{article.author}}</span>
			</div>
			<renderHTML class="article-content" :HTML="article.content"></renderHTML>
		</div>
		<div style="display: flex;justify-content: center;border-top: 1px solid #ddd;margin: 0 -7px;padding-top: 15px;">
			<el-button type="danger" @click="saveHandler('fail')" style="width: 120px;">审核不通过</el-button>
			<el-button type="primary" @click="saveHandler('published')" style="width: 120px;">审核通过</el-button>
			<el-button type="success" @click="cancel" style="width: 120px;">返回</el-button>
		</div>
	</div>
</template>

<script setup>
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'
	import {
		articleGetDetail,
		articlePut,
		columnGet
	} from "@/api/court"
	import {
		useRouter,
		useRoute
	} from "vue-router"
	import {
		ref,
		reactive,
		onMounted
	} from "vue"
	import {
		getTableHeight,
		buildTree
	} from "@/utils/util"
	import renderHTML from "@/components/renderHTML/index"

	const router = useRouter()
	const route = useRoute()
	const form = ref(null)
	const height = ref(500)
	const tree1 = ref(null)
	const tree2 = ref(null)
	
	const columns1 = ref([])
	const columns2 = ref([])
	const treeProps = {
		label: 'name',
		value: 'id',
		children: 'children',
		disabled: (data, node) => !data.is_enable
	}

	const article = reactive({
		title: "", //文章标题
		source: "", //文章来源
		column:[],
		sort: 0, //排序
		status: "", //状态
		content: "", //文章内容
		attachments: '', //上传文件
		creator:{},
		publish_time:""
	})


	function initPage() {
		columnGet({
			page: 1,
			limit: 10000,
			is_enable:true
		}).then(res => {
			if (res.code == 2000) {
				let arr = buildTree(res.data.data)
				columns1.value = arr.splice(0, 7)
				columns2.value = arr
			}
		})
		articleGetDetail(route.query.id).then(res => {
			if(res.data.code == 2000){
				delete res.data.data.data.update_datetime
				Object.assign(article,res.data.data.data)
				tree1.value.setCheckedNodes(article.column)
				tree2.value.setCheckedNodes(article.column)
				if(!article.publish_time)article.publish_time = article.create_datetime
			}
		})
	}

	function saveHandler(type) {
		article.column = tree1.value.getCheckedKeys().concat(tree2.value.getCheckedKeys())
		const param = JSON.parse(JSON.stringify(article))
		delete param.creator
		param.category = param.category.id
		param.status = type
		param.dept = null
		articlePut(param).then(res => {
			if (res.code == 2000) {
				ElMessage.success("文章审核成功~")
				router.go(-1)
			}
		})
	}

	//取消
	function cancel() {
		router.go(-1)
	}
	
	//获取表格高度
	function getTheTableHeight() {
		height.value = getTableHeight(0, false) - 240
	}

	onMounted(_ => {
		getTheTableHeight()
		initPage()
	})
</script>

<style scoped lang="scss">
	.article-title {
		text-align: center;
		color: #355e92;
		font-size: 22px;
		margin-bottom: 35px;
	}
	
	.article-desc {
		text-align: center;
		color: #777;
		margin-bottom: 55px;
	}
	
	.article-content {
		margin-bottom: 50px;
		padding-bottom: 30px;
	}
</style>